import React from 'react';
import withStyles from 'components/common/wrappers/withStyles';

function Payments({ color = 'white' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill={color} fillRule="nonzero" stroke="none" strokeWidth="1">
        <path
          d="M68.284 11.716C60.73 4.16 50.684 0 40 0 29.316 0 19.27 4.16 11.716 11.716 4.16 19.27 0 29.316 0 40c0 10.684 4.16 20.73 11.716 28.284C19.27 75.84 29.316 80 40 80c10.684 0 20.73-4.16 28.284-11.716C75.84 60.73 80 50.684 80 40c0-10.684-4.16-20.73-11.716-28.284zM40 75.313C20.529 75.313 4.688 59.47 4.688 40 4.688 20.529 20.528 4.688 40 4.688c19.471 0 35.313 15.84 35.313 35.312 0 19.471-15.842 35.313-35.313 35.313z"
          transform="translate(10 10)"
        />
        <path
          d="M42.51 37.656h-5.02a5.193 5.193 0 01-5.188-5.187 5.193 5.193 0 015.188-5.188H47.53a2.344 2.344 0 000-4.687h-5.187v-5.188a2.344 2.344 0 00-4.688 0v5.188h-.166c-5.445 0-9.875 4.43-9.875 9.875s4.43 9.875 9.875 9.875h5.02a5.193 5.193 0 015.188 5.187 5.193 5.193 0 01-5.187 5.188H32.469a2.344 2.344 0 000 4.687h5.187v5.188a2.344 2.344 0 004.688 0v-5.188h.166c5.445 0 9.875-4.43 9.875-9.875s-4.43-9.875-9.875-9.875z"
          transform="translate(10 10)"
        />
      </g>
    </svg>
  );
}

export default withStyles(Payments);
